"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AdvertPopupContextProvider = exports.useAdvertPopup = void 0;
var _react = _interopRequireWildcard(require("react"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _CookieAgreementsProvider = require("./CookieAgreementsProvider");
var _router = require("next/router");
var _LanguageProvider = require("./LanguageProvider");
var _isNewsletterEnabled = _interopRequireDefault(require("@deosite/helpers/isNewsletterEnabled"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n["default"] = e, t && t.set(e, n), n; }
var __jsx = _react["default"].createElement;
var AdvertPopupContext = /*#__PURE__*/_react["default"].createContext();
var AdvertPopupContextProvider = function AdvertPopupContextProvider(props) {
  var _useState = (0, _react.useState)(false),
    popupVisible = _useState[0],
    setPopupVisible = _useState[1];
  var _useState2 = (0, _react.useState)(false),
    dontDisplayAgain = _useState2[0],
    setDontDisplayAgain = _useState2[1];
  var _useCookieAgreements = (0, _CookieAgreementsProvider.useCookieAgreements)(),
    cookieAgreements = _useCookieAgreements.cookieAgreements;
  var isFirstRun = (0, _react.useRef)(true);
  var router = (0, _router.useRouter)();
  var _useLanguage = (0, _LanguageProvider.useLanguage)(),
    language = _useLanguage.language;
  var displayConfig;
  var displayConfigStorage;
  var setCookie = function setCookie() {
    _jsCookie["default"].set("AdvertPopupDisplayed", true, {
      expires: 60
    });
  };
  var killPopup = function killPopup() {
    setPopupVisible(false);
    dontDisplayAgain && setCookie();
  };
  var displayPopup = function displayPopup(config) {
    if (config.showToKnownUsers === false && config.isKnownUser) {
      setCookie();
      setDontDisplayAgain(true);
      return;
    }
    if ((0, _isNewsletterEnabled["default"])({
      language: language.language
    })) {
      setTimeout(function () {
        setPopupVisible(true);
      }, config.popupDelay === undefined ? 0 : config.popupDelay);
    }
  };
  var cookie = _jsCookie["default"].get("AdvertPopupDisplayed");
  (0, _react.useEffect)(function () {
    var _displayConfig;
    if (dontDisplayAgain) {
      return;
    }
    if (isFirstRun.current && cookieAgreements !== null && cookieAgreements !== void 0 && cookieAgreements.salesmanago) {
      var _localStorage, _displayConfigStorage, _displayConfigStorage2;
      displayConfigStorage = JSON.parse((_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.getItem("_smvc"));
      var configDataArray = (_displayConfigStorage = displayConfigStorage) === null || _displayConfigStorage === void 0 ? void 0 : (_displayConfigStorage2 = _displayConfigStorage._v) === null || _displayConfigStorage2 === void 0 ? void 0 : _displayConfigStorage2.i;
      if ((configDataArray === null || configDataArray === void 0 ? void 0 : configDataArray.length) > 0) {
        displayConfig = {
          showToKnownUsers: configDataArray[0].ohp,
          popupDelay: configDataArray[0].cfg.delay,
          dontShowAfterClose: configDataArray[0].cfg.nsa.close,
          displayOnSpecificUrl: configDataArray[0].url,
          dontDisplayUrl: configDataArray[0].exurl,
          isKnownUser: configDataArray[0].monitored === "I"
        };
        if (cookie === undefined) {
          if (displayConfig.displayOnSpecificUrl.length > 0 && displayConfig.displayOnSpecificUrl.includes(router.asPath.slice(1)) === false || displayConfig.dontDisplayUrl.length > 0 && displayConfig.dontDisplayUrl.includes(router.asPath.slice(1)) === true) {
            return;
          }
          displayPopup(displayConfig);
        }
      }
    }
    isFirstRun.current = false;
    if (!dontDisplayAgain && (_displayConfig = displayConfig) !== null && _displayConfig !== void 0 && _displayConfig.dontShowAfterClose) {
      setDontDisplayAgain(true);
    }
  });
  return __jsx(AdvertPopupContext.Provider, {
    value: {
      popupVisible: popupVisible,
      killPopup: killPopup
    }
  }, props.children);
};
exports.AdvertPopupContextProvider = AdvertPopupContextProvider;
var useAdvertPopup = function useAdvertPopup() {
  return (0, _react.useContext)(AdvertPopupContext);
};
exports.useAdvertPopup = useAdvertPopup;